import { render, staticRenderFns } from "./PictureGallary.vue?vue&type=template&id=53ffb48c&scoped=true&"
import script from "./PictureGallary.vue?vue&type=script&lang=js&"
export * from "./PictureGallary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ffb48c",
  null
  
)

export default component.exports